import { useState } from "react";
import { Modal, Button, Form, Table, Badge } from "react-bootstrap";
import HRMSApi from "../../api/HRMSApi";
import { toast } from "react-toastify";

const LeaveRejectTable = ({ setShimmer, showRejectionModal, setShowRejectionModal, fetchTeamLeaves, pendingRecord, setPendingRecord }) => {
    const [rejectReason, setRejectReason] = useState("");
    const [rejectReasonTouched, setRejectReasonTouched] = useState(false);

    const closeModal = () => {
        setShowRejectionModal(!showRejectionModal);
    };

    const handleReasonChange = (id, value) => {
        const updated = pendingRecord.map((leave) =>
            leave.id === id ? { ...leave, rejectReason: value } : leave
        );
        setPendingRecord(updated);
    };

    const handleRejectSubmit = async () => {
        setShimmer(true);

        try {
            const hasEmptyReason = pendingRecord.some(
                (leave) => !leave.rejectReason || leave.rejectReason.trim() === ""
            );

            if (hasEmptyReason) {
                toast.error("Please provide a rejection reason for all selected leaves.");
                return;
            }

            // Build payload
            const leaveIds = pendingRecord.map(leave => leave.id);

            const rejectionReasons = pendingRecord.reduce((acc, leave) => {
                acc[leave.id] = leave.rejectReason;
                return acc;
            }, {});

            const payload = {
                leaveIds,
                status: "Rejected",
                rejectionReasons
            };

            // API call
            const result = await HRMSApi.updateApprovalRequest(payload);

            if (!result || !result.success) {
                toast.error(result?.message || "Failed to reject leave requests.");
                return;
            }

            if (result.totalFailed === 0) {
                toast.success(`${result.totalProcessed} leave(s) rejected successfully!`);
            } else {
                toast.warning(
                    `${result.totalProcessed} leave(s) rejected, ${result.totalFailed} failed.`
                );
            }

            fetchTeamLeaves();
            closeModal();

        } catch (error) {
            toast.error(error.message || "Something went wrong while rejecting leaves.");
        } finally {
            setShimmer(false); // 🔵 hide loader in all cases
        }
    };



    return pendingRecord && (
        <div className="p-4">
            <Modal show={showRejectionModal} onHide={closeModal} centered size="lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Reject Leave Request</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Table bordered hover>
                        <thead className="table-light">
                            <tr>
                                <th>Leave Date</th>
                                <th>Employee Name</th>
                                <th>Rejection Reason</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pendingRecord.map((row, index) => (
                                <tr key={row.id}>
                                    <td>{row.startDate}</td>
                                    <td>{row.employeeName}</td>

                                    <td>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            value={row.rejectionReason}
                                            required
                                            placeholder="Enter Rejection Reason"
                                            onChange={(e) =>
                                                handleReasonChange(row.id, e.target.value)
                                            }
                                        />
                                    </td>

                                    <td>
                                        <Badge bg={row.status === "Rejected" ? "danger" : "secondary"}>
                                            {row.status}
                                        </Badge>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleRejectSubmit}>
                        Reject Leave
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default LeaveRejectTable;
